<template>
  <v-flex
    pt-1
    pl-2
    style="color: #000000; font-size: 13px"
  >
    <v-layout>
      <v-flex>
        <p
          v-if="currentlyShowing && currentlyShowing.driver"
        >
          <span class="cmr-driver-state-name">
            {{ currentlyShowing.driver.taxi && currentlyShowing.driver.taxi.state ? currentlyShowing.driver.taxi.state.replace("_", " ").toUpperCase() : '' }}
          </span>
          |
          <span class="cmr-driver-eta">{{ currentlyShowing.minutes_from_pickup }} mins</span>
          |
          <span class="cmr-driver-state-name">
            {{ currentlyShowing.driver.callsign }}
            {{ currentlyShowing.driver.name.substr(0, 5) }}
          </span>
        </p>
      </v-flex>
      <v-flex>
        <BookTripETARoute :booking-form="bookingForm" />
      </v-flex>
      <v-flex
        class="d-flex justify-end"
        align-self-end
      >
        <span class="pb-4">
          <small v-if="nearest5 && nearest5.length">
            {{ (currentDriverIndex+1) + ' of ' + nearest5.length }}
          </small>
          <v-icon
            :color="currentDriverIndex == 0 ? 'grey' : '' "
            class="pa-0 pb-1"
            small
            @click="decrementDriverIndex"
          >mdi-chevron-left-box</v-icon>
          <v-icon
            :color="nearest5 && currentDriverIndex == (nearest5.length - 1) ? 'grey' : '' "
            class="pa-0 pb-1"
            small
            @click="incrementDriverIndex"
          >mdi-chevron-right-box</v-icon>
        </span>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
import moment from "moment";

import { Overwatch } from "@/components/util/Overwatch.js";

import BookTripETARoute from "@/components/widget/input/BookTripETARouteV2.vue";


export default {
  name: "BookingNearestDriverSummaryV2",
  components: {
    BookTripETARoute,
  },
  model: {
    prop: "preassignedDriver",
    event: "input"
  },
  props: {
    taxis: Array,
    bookingForm: Object,
    zones: Array
  },
  data() {
    return {
      currentDriverIndex: 0,
      menu: false,
      drivers: [],
      loading: false
    };
  },
  computed: {
    pickupTimeETA: function() {
      if (!this.currentlyShowing) {
        return null;
      }

      var put = this.bookingForm.booking.pickup_datetime;

      if (put == null) {
        put = new Date();
      }

      return moment(put).add(this.currentlyShowing.minutes_from_pickup, "minutes").format("HH:mm");
    },
    bestDriver: function () {
      return this.bookingForm.booking.bestDriver;
    },
    currentlyShowing: function () {
      if (this.nearest5 && this.nearest5.length) {
        return this.nearest5[this.currentDriverIndex] ? this.nearest5[this.currentDriverIndex] : null;
      }
      return null
    },
    nearest5: function () {
      return this.bookingForm.booking.nearest5;
    },
    items: function() {
      return this.bookingForm.booking.eligibleDriversForPreassign;
    },
    taxisForZone: function() {

      var self = this;

      if (self.bookingForm == null  || self.bookingForm.booking.zone == null) {
        return [];
      }

      return this.taxis.filter(function(t) {
        return t.zone == self.bookingForm.booking.zone.id;
      });
    },
    freeTaxisForZone: function(id) {
      return this.taxisForZone.filter(function(t) {
        return t.state == 'available';
      })
    },
  },
  watch: {
    currentlyShowing () {
      this.bookingForm.currentlyShowing = this.currentlyShowing
      this.$emit("driverIndexUpdated", {pickupTimeETA: this.pickupTimeETA, driver: this.currentlyShowing.driver, minutesFromPickup: this.currentlyShowing.minutes_from_pickup})
    }
  },
  methods: {
    decrementDriverIndex () {
      if (this.currentDriverIndex > 0) {
        this.currentDriverIndex--;
      }
    },
    incrementDriverIndex () {
      if (this.nearest5 && this.currentDriverIndex < this.nearest5.length -1) {
        this.currentDriverIndex++;
      }
    },
    valid() {
      // console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    willBeActive(p) {
      return this.bookingForm.promocodeWillBeActive(p);
    },
    htmlForDriver(item) {
      return (
        "<p><b>" + item.callsign + "&nbsp;-&nbsp;</b>" + item.name + "</p>"
      );
    },
    htmlForPromocodeExtended(item) {
      return (
        "<p><b>" +
        item.promocode.code +
        "</b><br>" +
        item.promocode.promotion.description
      );
    },
    updateSelf(rideType) {
      this.$emit("input", rideType);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");

      this.bookingForm.getEligibleDriversForPreassign();

      this.$forceUpdate();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
